import i18n from '@/services/i18n'

export const WALLET_TYPE = () => ({
  '': '',
  1: i18n.t('common.asset'),
  2: 'Web3',
})

export const DEFAULT_PAGE_SIZE = 20

export const DEFAULT_WALLET_LIST_PAGE_SIZE = 24

export const CURRENCY = 'USD'
export const RSA_KEY_BEGIN = '-----BEGIN PUBLIC KEY-----'
export const RSA_KEY_END = '-----END PUBLIC KEY-----'
export const LOOP_FEE_INTERVAL = 10
export const MIN_SCREEN_WIDTH = 1380
export const threeMonth = 1000 * 3600 * 24 * 30 * 3
export const dateSelectLimit = 1000 * 3600 * 24 * 365
// 格式化导出内容
export const format = 'YYYY.MM.DD'
